import {FC, useState} from 'react'
import { Alert } from 'react-bootstrap'
import './AlertMsg.css'

export interface AlertMsgModel {
  title: string
  message: string
  status?: boolean
  // Optional explicit Bootstrap variant. When set it overrides the
  // success/danger pair derived from `status` — e.g. 'warning' (yellow)
  // for non-celebratory actions like pausing an offer.
  variant?: 'success' | 'danger' | 'warning'
}

interface IProps extends AlertMsgModel {
  onClose: () => void
}
const AlertMessage: FC<IProps> = ({title, message, status, variant, onClose}) => {
    const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    if (onClose)
      onClose()
  }

  const resolvedVariant = variant ?? (status ? 'success' : 'danger')

  return (
    <>
      <Alert className={`popup-alert fixed-bottom w-300px`} show={show} variant={resolvedVariant} onClose={handleClose} dismissible>
        <Alert.Heading>{title}</Alert.Heading>
        <p>
          {message}
        </p>
      </Alert>

    </>
  )
}

export default AlertMessage
